import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-right\">\n    <title>icon/基础图标/方向</title>\n    <g id=\"icon-arrow-right_icon/基础图标/方向\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" stroke-linejoin=\"round\">\n        <polyline id=\"icon-arrow-right_路径备份\" stroke=\"currentColor\" stroke-width=\"10\" transform=\"translate(52.6802, 48.1127) rotate(45) translate(-52.6802, -48.1127)\" points=\"30.6801948 26.1126984 74.6801948 26.1126984 74.6801948 70.1126984\" />\n        <line x1=\"81\" y1=\"48\" x2=\"17\" y2=\"48\" id=\"icon-arrow-right_路径-2备份\" stroke=\"currentColor\" stroke-width=\"10\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-right.svg
// module id = dxdv
// module chunks = 3